<script setup>






</script>

<template>
  <header>

    <div class="header-contain">
        <picture class="header-logo">
          <img
              src="https://objectstorage.sa-bogota-1.oraclecloud.com/n/axwjzswungq4/b/Champions_bucket/o/recursos%2Flogo-champions.png"
              alt="logo">
        </picture>


    </div>
  </header>

</template>

<style scoped>

</style>
